export default "__VITE_ASSET__ffc7576b__"